import React from "react";

import { LocalizationProvider } from "@mui/lab";
import DateAdapter from "@mui/lab/AdapterMoment";

import { ThemeProvider } from "@mui/material/styles";

import ErrorBoundary from "commons/components/ErrorBoundary";

import { CursorContextProvider } from "commons/context/cursor";
import { DateFormatContextProvider, DateFormatType } from "commons/context/dateFormat";

import moment from "commons/utils/moment";

import RoutesContainer from "components/layout/routes/RoutesContainer";

import { ConfigContextProvider } from "context/config";

import theme from "styles/theme";

import packageJson from "../package.json";

function App() {
    console.log("UI", packageJson.version);

    const dateFormat: DateFormatType = React.useMemo(
        (): DateFormatType => ({
            momentDate: "DD.MM.YY",
            momentDateTime: "DD.MM.YY HH:mm:ss",
            momentDateTimeWoSeconds: "DD.MM.YY HH:mm",
            momentTime: "HH:mm:ss",
            momentTimeWoSeconds: "HH:mm",
            momentMonth: "MMMM YYYY",
            momentNumberMonth: "MM.YYYY",
            placeholderDate: "GG.MM.AA",
            placeholderYearMonth: "MM.AAAA",
            maskDate: "99.99.99",
            maskDateTime: "99.99.99 99.99",
            maskTime: "99.99",
            maskYearMonth: "99.9999",
            separator: "alle",
        }),
        []
    );

    return (
        <ThemeProvider theme={theme}>
            <LocalizationProvider dateLibInstance={moment} dateAdapter={DateAdapter} locale={"it"}>
                <DateFormatContextProvider format={dateFormat}>
                    <ErrorBoundary redirectUrl={"/backoffice-ui"}>
                        <CursorContextProvider>
                            <ConfigContextProvider>
                                <RoutesContainer />
                            </ConfigContextProvider>
                        </CursorContextProvider>
                    </ErrorBoundary>
                </DateFormatContextProvider>
            </LocalizationProvider>
        </ThemeProvider>
    );
}

export default App;
